import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { assetImg } from "@/modules/moduleImporter";
import { IGameTableType } from "@/types/GlobalTypes";

import "./index.scss";
import nary from "@/modules/nary";
import Nnary from "@/modules/Nnary";

//p12: Sicbo[Dice]
//m31: 3D (Sicbo Machine)
//m37: bingo sicbo
//Todo: solve assetImg key errors
export default class P12 extends React.PureComponent<IGameTableType> {
	render() {
		const { langdata } = this.props;

		//For yellow win indicator
		const pcode = this.props.pcode;
		const assetExtension = pcode === "m31" ? ".svg" : "";

		const assetsImgpcode = pcode === "m37" ? "p12" : pcode;

		const win = this.props.win || "";
		const winsplit = win.split(",").map(item => Number(item));
		
		const winCount = {};
		let anyTriple = false;
		winsplit.forEach(item => { 
			if (!winCount[item])
				winCount[item] = 0;
			winCount[item] += 1; 
			if (winCount[item] === 3)
				anyTriple = true;
		});
		
		const total = winsplit.reduce((a, b) => a + b);

		// const numnames = ["One", "Two", "Three", "Four", "Five", "Six"];
		const numnames = [
			langdata["txt_one"],
			langdata["txt_two"],
			langdata["txt_three"],
			langdata["txt_four"],
			langdata["txt_five"],
			langdata["txt_six"]
			];

		const flexBetType = ["1:50", "1:30", "1:18", "1:12", "1:8", "1:6", "1:6", "1:6", "1:6", "1:8", "1:12", "1:18", "1:30", "1:50"];
		// const bottomBetType = ["1:1 ON ONE DICE","1:1 ON ONE DICE","2:1 ON ONE DICE","2:1 ON ONE DICE","3:1 ON ONE DICE","3:1 ON ONE DICE"];
		const bottomBetType = [
			"1:1 " + langdata["txt_on_one_dice"],
			"1:2 " + langdata["txt_on_two_dice"],
			"1:3 " + langdata["txt_on_three_dice"]
			];

		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		const big = (
			<div key={pcode + "_g_big"} className="sl-green-new">
				<div className={"p12-top-half sl-bet" + (!anyTriple && 10 < total && total < 18 ? " sl-yellow-alternating" : "")}
				{...{
					bet: "Big",
					pcode: this.props.pcode,
					group: "n50"
				}}
					onClick={this.props.insertBet}>

					<div>{langdata["txt_big"]}</div>

					<div className="bet-type">1:1</div>
					<Chips {...commonChipProps} betKey="Big+n50" />
					<Tooltip {...commonTooltipProps} bet={this.props.bets["Big+n50"]} />
				</div>
			</div>
		);
		
		const even = (
			<div key={pcode + "_g_even"} className="sl-cyan-new">
				<div className={"p12-top-half sl-bet" + (!anyTriple && !(total % 2) && total > 0 ? " sl-yellow-alternating" : "")}

				{...{
					bet: "Even",
					pcode: this.props.pcode,
					group: "n50"
				}}

					onClick={this.props.insertBet}>

					<div>{langdata["txt_even"]}</div>
					{/*  this.props.maximised ? <div>Even</div> : <div>EVEN</div>  */}
					<div className="bet-type">1:1</div>
					<Chips {...commonChipProps} betKey="Even+n50" />
					<Tooltip {...commonTooltipProps} bet={this.props.bets["Even+n50"]} />
				</div>
			</div>
		);
		
		const betKeyPcode = (bet: string, group: string) => {
			return {bet: bet, pcode: this.props.pcode, group: group};
		};

		return (
		this.props.portrait ?
			<div className="sl-table p12-portrait">
				<div className="row">
					<div className={"col-xs-6 sl-green-new sl-bet" + (!anyTriple && 3 < total && total < 11 ? " sl-yellow-alternating" : "")}
						
						{...betKeyPcode("Small", "n50")}

						onClick={this.props.insertBet}>

						<div>{langdata["txt_small"]}</div>
						<div className="bet-type">1:1</div>
						<Chips {...commonChipProps} betKey="Small+n50" />
					</div>

					<div className={"col-xs-6 sl-green-new sl-bet" + (!anyTriple && 10 < total && total < 18 ? " sl-yellow-alternating" : "")}

						{...betKeyPcode("Big", "n50")}

						onClick={this.props.insertBet}>
						
						<div>{langdata["txt_big"]}</div>
						<div className="bet-type">1:1</div>
						<Chips {...commonChipProps} betKey="Big+n50" />
					</div>
				</div>
					

				<div className="row">
					<div className={"col-xs-6 sl-cyan-new sl-bet" + (!anyTriple && total % 2 ? " sl-yellow-alternating" : "")}
						
						{...betKeyPcode("Odd", "n50")}
							
						onClick={this.props.insertBet}>
						
						<div>{langdata["txt_odd"]}</div>
						<div className="bet-type">1:1</div>
						<Chips {...commonChipProps} betKey="Odd+n50" />
					</div>
					<div className={"col-xs-6 sl-cyan-new sl-bet" + (!anyTriple && total % 2 === 0 && win !== "" ? " sl-yellow-alternating" : "")}
						
						{...betKeyPcode("Even", "n50")}
						
						onClick={this.props.insertBet}>

						<div>{langdata["txt_even"]}</div>
						<div className="bet-type">1:1</div>
						<Chips {...commonChipProps} betKey="Even+n50" />
					</div>
				</div>
				
				<div className="row">
				{
					nary(3).map((num, idx) =>
						<div key={pcode + " tbt " + idx} className="col-xs-4 p12-top-bet-types sl-green-old">
							<div className="bet-type">{bottomBetType[idx]}</div>
						</div>
					)
				}
				</div>
				
				<div className="row">
				{
					nary(6).map((num, idx) => {
						const group = `n`;
						const betKey = `${num}+${group}`;
						
						return (
							<div key={pcode + "t" + idx}
								className={"sl-bet col-xs-2 p12-top p12-main-bets sl-green-old" + (winsplit.indexOf(num) >= 0 ? " sl-yellow-alternating" : "")}
								
								{...{
								bet: num,
								pcode: this.props.pcode,
								group: group
								}}

								onClick={this.props.insertBet}>

								{ assetImg(assetsImgpcode, num + assetExtension, "nPortrait1_" + idx, "shadowed") }
								<Chips {...commonChipProps} betKey={betKey} />
							</div>
						);
					})
				}
				</div>

				<div className="row">
				{
					nary(6).map((num, idx) => {
						const betKey = num + "," + num;
						return (
							<div key={pcode + "mid" + num} className={"sl-bet col-xs-2 p12-stacks sl-green-old" + (winCount[num] === 2 ? " sl-yellow-alternating" : "")}

								{...betKeyPcode(betKey, "d")}
								// bet={betKey} pcode={this.props.pcode} group="d"
								onClick={this.props.insertBet}>

								{ assetImg(assetsImgpcode, num + assetExtension, "nPortrait2_1_" + idx, "shadowed") }
								{ assetImg(assetsImgpcode, num + assetExtension, "nPortrait2_2_" + idx, "shadowed") }
								<div className="bet-type">1:10</div>
								<Chips {...commonChipProps} betKey={betKey + "+d"} />
							</div>
						);
					})
				}
				</div>
			
				<div className="row">
				{
					nary(6).map((num, idx) => {
						const betKey = num + "," + num + "," + num;
						return <div key={pcode + "mid" + betKey} className={"sl-bet col-xs-2 p12-stacks sl-green-old" + (betKey === win ? " sl-yellow-alternating" : "")}

								{...betKeyPcode(betKey, "t")}

								//bet={betKey} pcode={this.props.pcode} group="t"
								onClick={this.props.insertBet}>

							{ assetImg(assetsImgpcode, num + assetExtension, "nPortrait3_1_" + idx, "shadowed") }
							{ assetImg(assetsImgpcode, num + assetExtension, "nPortrait3_2_" + idx, "shadowed") }
							{ assetImg(assetsImgpcode, num + assetExtension, "nPortrait3_3_" + idx, "shadowed") }
							<div className="bet-type">1:180</div>
							<Chips {...commonChipProps} betKey={betKey + "+t"} />
						</div>;
					})
				}
				</div>
				
				<div className="row">
					<div className={"sl-bet col-xs-12 sl-green-old" + (anyTriple ? " sl-yellow-alternating" : "")}
							{...betKeyPcode("anytriple", "triple")}
							// bet="anytriple" pcode={this.props.pcode} group="triple"
							onClick={this.props.insertBet}>
						<div>{langdata["txt_any_triple"]}</div>
						{/* Any Triple */}
						<div className="bet-type">1:30</div>
						<Chips {...commonChipProps} betKey="anytriple+triple" />
					</div>
				</div>

				<div className="row" style={{textAlign: "center"}}>
				{
					[4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].map((num, idx) => {
						// const colourClass = num < 11 ? "sl-cyan-new" : "sl-red";
						
						return (
							<div key={pcode + "s" + num}
								className={"sl-bet col-20p sl-green-old" +
									(total === num ? " sl-yellow-alternating" : "")
									// + (" " + colourClass)
									}


								{...betKeyPcode(num + "", "s")}
								// bet={num} pcode={this.props.pcode} group="s"

								onClick={this.props.insertBet}>
								<div>{num}</div>
								<div className="bet-type">{flexBetType[idx]}</div>
								<Chips {...commonChipProps} betKey={num + "+s"} />
							</div>
						);
					})
				}
				</div>
				
				<div className="row">
				{
					["1,2", "1,3", "1,4", "1,5", "1,6", "2,3", "2,4", "2,5", "2,6", "3,4", "3,5", "3,6", "4,5", "4,6", "5,6"].map((item, idx) => {
						//"rdrdrdrdrdrdrdr"
						const splitt = item.split(",");
						return (
						<div key={pcode + "c" + item}
							className={"sl-bet col-20p p12-tall sl-green-old" + (winsplit.indexOf(+splitt[0]) >= 0 && winsplit.indexOf(+splitt[1]) >= 0 ? " sl-yellow-alternating" : "")}
						
							{...betKeyPcode(item, "c")}
						
							onClick={this.props.insertBet}>
							{ assetImg(assetsImgpcode, splitt[0] + assetExtension, "nPortrait4_1_" + idx, "shadowed") }
							{ assetImg(assetsImgpcode, splitt[1] + assetExtension, "nPortrait4_2_" + idx, "shadowed") }
							<div className="bet-type">1:5</div>
							<Chips {...commonChipProps} betKey={item + "+c"} />
						</div>
						);
					})
				}
				</div>
			</div>
		
		: <div className="sl-table p12">
				<div className="top-row">
					<div className="top-col-1">
						<div className="sl-green-new">
							<div className={"p12-top-half sl-bet" + (!anyTriple && 3 < total && total < 11 ? " sl-yellow-alternating" : "")}
								{...betKeyPcode("Small", "n50")}
								onClick={this.props.insertBet}>
								
								<div>{langdata["txt_small"]}</div>
								<div className="bet-type">1:1</div>
								<Chips {...commonChipProps} betKey="Small+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["Small+n50"]} />
							</div>
						</div>
						<div className="sl-cyan-new">
							<div className={"p12-top-half sl-bet" + (!anyTriple && total % 2 ? " sl-yellow-alternating" : "")}
								{...betKeyPcode("Odd", "n50")}
								onClick={this.props.insertBet}>

								<div>{langdata["txt_odd"]}</div>
								<div className="bet-type">1:1</div>
								<Chips {...commonChipProps} betKey="Odd+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["Odd+n50"]} />
							</div>
						</div>
					</div>
					
					<div className="sl-green-old p12-two-three">
					{
						"123".split("").map((item, idx) => {
							const betKey = item + "," + item;
							return (
								<div key={`${pcode}_g_23_${idx}`}
									className={"sl-bet" + (winCount[item] === 2 ? " sl-yellow-alternating" : "")}
									
									{...betKeyPcode(betKey, "d")}

									// bet={betKey}
									// pcode={this.props.pcode}
									// group="d"
									onClick={this.props.insertBet}>
									{ assetImg(assetsImgpcode, item + assetExtension, "p12_1_1_" + idx, "shadowed") }
									{ assetImg(assetsImgpcode, item + assetExtension, "p12_1_2_" + idx, "shadowed") }
	
									<Chips between={true} {...commonChipProps} betKey={betKey + "+d"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+d"]} />
								</div>
							);
						})
					}
						<div className="bet-type">1:10</div>
					</div>
					
					<div className="sl-green-old p12-three-three">
					{
						"123".split("").map((item, idx) => {
							const betKey = item + "," + item + "," + item;
							return (
								<div key={`${pcode}_g_33_${idx}`} className={"sl-bet" + (betKey === win ? " sl-yellow-alternating" : "")}
									{...betKeyPcode(betKey, "t")}
									// bet={betKey} pcode={this.props.pcode} group="t"
									onClick={this.props.insertBet}>
									{ assetImg(assetsImgpcode, item + assetExtension, "p12_2_1_" + idx, "shadowed") }
									{ assetImg(assetsImgpcode, item + assetExtension, "p12_2_2_" + idx, "shadowed") }
									{ assetImg(assetsImgpcode, item + assetExtension, "p12_2_3_" + idx, "shadowed") }
									<Chips between={true} {...commonChipProps} betKey={betKey + "+t"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+t"]} />
								</div>
							);
						})
					}
						<div className="bet-type">1:180</div>
					</div>
					
					<div className="sl-green-old p12-any-triple">
						<div className={"sl-bet" + (anyTriple ? " sl-yellow-alternating" : "")}
							
							{...betKeyPcode("anytriple", "triple")}

							onClick={this.props.insertBet}>

							<div>{langdata["txt_any_triple"]}</div>

							<div className="bet-type">1:30</div>
							<Chips {...commonChipProps} betKey="anytriple+triple" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["anytriple+triple"]} />
						</div>
					</div>
					
					<div className="sl-green-old p12-three-three">
					{
						"456".split("").map((item, idx) => {
							const betKey = item + "," + item + "," + item;
							return (
								<div key={`${pcode}_g_33_2_${idx}`} className={"sl-bet" + (betKey === win ? " sl-yellow-alternating" : "")}
									
									{...betKeyPcode(betKey, "t")}

									onClick={this.props.insertBet}>
									{ assetImg(assetsImgpcode, item + assetExtension, "p12_3_1_" + idx, "shadowed") }
									{ assetImg(assetsImgpcode, item + assetExtension, "p12_3_2_" + idx, "shadowed") }
									{ assetImg(assetsImgpcode, item + assetExtension, "p12_3_3_" + idx, "shadowed") }
									<Chips between={true} {...commonChipProps} betKey={betKey + "+t"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+t"]} />
								</div>
							);
						})
					}
						<div className="bet-type">1:180</div>
					</div>
					
					<div className="sl-green-old p12-two-three">
					{
						"456".split("").map((item, idx) => {
							const betKey = item + "," + item;
							return (<div key={`${pcode}_g_23_2_${idx}`} className={"sl-bet" + (winCount[item] === 2 ? " sl-yellow-alternating" : "")}
								
								{...betKeyPcode(betKey, "d")}
								//bet={betKey} pcode={this.props.pcode} group="d"
								onClick={this.props.insertBet}>

								{ assetImg(assetsImgpcode, item + assetExtension, "p12_4_1_" + idx, "shadowed") }
								{ assetImg(assetsImgpcode, item + assetExtension, "p12_4_2_" + idx, "shadowed") }
								<Chips between={true} {...commonChipProps} betKey={betKey + "+d"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+d"]} />
							</div>);
						})
					}
						<div className="bet-type">1:10</div>
					</div>
					
					<div className="top-col-1">
						{ this.props.maximised ? [even, big] : [big, even] }
					</div>
				</div>

				<div className="amount-row sl-flex">
				{
					Nnary(4, 17).map((num, idx) => {
						return (
							<div key={`${pcode}_g_s_${idx}`}
								className={"sl-bet sl-green-old " +
									(total === num ? " sl-yellow-alternating" : "")
									// + " " + colourClass
									}

								{...betKeyPcode(num + "", "s")}

								onClick={this.props.insertBet}>
								<div className="p12-medium-text-only p12-text-medium">{num}</div>
								<div className="bet-type">{flexBetType[idx]}</div>
								
								<Chips {...commonChipProps} betKey={num + "+s"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[num + "+s"]} />
							</div>
						);
					})
				}
				</div>
				<div className="double-dice-row">
				{
					["1,2", "1,3", "1,4", "1,5", "1,6", "2,3", "2,4", "2,5", "2,6", "3,4", "3,5", "3,6", "4,5", "4,6", "5,6"].map((item, idx) => {
						//"rdrdrdrdrdrdrdr"
						const splitt = item.split(",");
						
						return (<div key={`${pcode}_g_c_${idx}`} className={" sl-bet p12-medium sl-green-old"
								/* + (idx % 2 ? "-darken " : "")  */
									+ (
										winsplit.indexOf(+splitt[0]) >= 0 &&
										winsplit.indexOf(+splitt[1]) >= 0 ? " sl-yellow-alternating" : ""
									)}

									{...betKeyPcode(item, "c")}

									onClick={this.props.insertBet}>

							{ assetImg(assetsImgpcode, splitt[0] + assetExtension, `${pcode}_g_c_${splitt[0]}`) }
							<br/>
							{ assetImg(assetsImgpcode, splitt[1] + assetExtension, `${pcode}_g_c_${splitt[1]}`) }
							
							{ (item === "1,2" || item === "2,5" || item === "5,6") && <div className="bet-type">1:5</div> }
							
							<Chips {...commonChipProps} betKey={item + "+c"} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+c"]} />
						</div>);
					})
				}
				</div>

				<div className="single-dice-row">
				{
					nary(6).map((num, idx) => {
						const group = `n`;
						const betKey = `${num}+${group}`;
						
						return <div key={`${pcode}_g_n_${idx}`} className={" sl-bet sl-green-old p12-bottom" + (winsplit.indexOf(num) >= 0 ? " sl-yellow-alternating" : "")}
							
							{...betKeyPcode(num + "", group)}
							onClick={this.props.insertBet}>
							{ 
								this.props.maximised ? (
								<div>
									{ numnames[idx] }
									{ assetImg(assetsImgpcode, num + assetExtension, `${pcode}_g_n_${num}`) }
								</div>
								) :
								assetImg(assetsImgpcode, num + assetExtension, `${pcode}_g_n_${num}`)
							}
							<Chips between={true} {...commonChipProps} betKey={betKey} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey]} />
						</div>;
					})
				}
				</div>
				<div>
				{
					nary(3).map((num, idx) =>
						<div key={`${pcode}_g_types_${idx}`} className="sl-green-old p12-bottom-text">
							<div className="bet-type">{bottomBetType[idx]}</div>
						</div>
					)
				}
				</div>
				
			</div>
		);
	}
}
